exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.modal-body {\r\n    height: 580px !important;\r\n    overflow-y: scroll;\r\n}\r\n\r\n.container {\r\n    max-width: 570px !important;\r\n}\r\n\r\nlegend a {\r\n    color: inherit;\r\n}\r\n\r\nlegend.legend-style {\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n}\r\n\r\nfieldset.fsStyle {\r\n    font-family: Verdana, Arial, sans-serif;\r\n    font-size: small;\r\n    font-weight: normal;\r\n    border: 1px solid #c0c0c0;\r\n    padding: 4px;\r\n    margin: 5px;\r\n}\r\n\r\nlegend.legend-style {\r\n    font-size: 90%;\r\n    color: #888888;\r\n    background-color: transparent;\r\n    font-weight: bold;\r\n}\r\n\r\nlegend {\r\n    width: auto;\r\n    border-bottom: 0px;\r\n}\r\n\r\n.modules {\r\n    margin-bottom: 3px;\r\n    padding-left: 10px;\r\n    font-weight: bold;\r\n}\r\n\r\n.information-module {\r\n    cursor: pointer;\r\n    color: #3c8dbc;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/register/show-modules/show-modules.component.css
// module id = ../../../../../src/app/_components/register/show-modules/show-modules.component.css
// module chunks = main